import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "form-control" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "▼", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "pt-2" }, "x:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "pt-2" }, "y:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "pt-2" }, "z:", -1)
const _hoisted_7 = { key: 0 }

import {  onMounted, ref, computed } from "vue";
interface Prop {
  node: Node;
  save: () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PositionEditorNode',
  props: {
    node: { default: () => new Node() },
    save: null
  },
  setup(__props: any) {

const props = __props as { node: Node, save: () => void };


const selectedNode = props.node as any;
const isOpenedDetail = ref(false);
const x = ref(0);
const y = ref(0);
const z = ref(0);
const posX = computed({
  get: () => selectedNode.object3D.position.x,
  set: (val) => {
    x.value = val;
    selectedNode.object3D.position.x = val;
  },
});
const posY = computed({
  get: () => selectedNode.object3D.position.y,
  set: (val) => {
    y.value = val.value;
    selectedNode.object3D.position.y = val;

  },
});
const posZ = computed({
  get: () => selectedNode.object3D.position.z,
  set: (val) => {
    z.value = val;
    selectedNode.object3D.position.z = val;
  },
});

/**
 * 動く物体は、Kinematicに一度変換しないと動かない。DomのDatasetにDynamicであることを記憶しておく
 * 
 */
const focusin = ()=>{
  const ammoAttr = selectedNode.getAttribute("autofit-ammo");
  if(ammoAttr && ammoAttr.type === "dynamic"){
    selectedNode.dataset.isDynamic = true
    ammoAttr.type = "kinematic";
    selectedNode.removeAttribute("autofit-ammo");
    selectedNode.setAttribute("autofit-ammo",ammoAttr);
  }
}

/**
 * 動く物体を移動させたときにDynamicだったものは書き戻す。
 */
const focusout = ()=>{
  if(selectedNode.dataset.isDynamic ){
    const ammoAttr = selectedNode.getAttribute("autofit-ammo");
    ammoAttr.type = "dynamic";
    selectedNode.removeAttribute("autofit-ammo");
    selectedNode.setAttribute("autofit-ammo",ammoAttr);
  }


}

onMounted(() => {
  const pos = selectedNode.getAttribute("position");
  x.value = pos.x;
  y.value = pos.y;
  z.value = pos.z;
});
const onClickOpenDetail = () => {
  isOpenedDetail.value = !isOpenedDetail.value;
};

// ノードの属性を文字列にする
const attributesStr = Array.from(selectedNode.attributes)
  .map((n: Attr) => `${n.name}="${n.value}"`)
  .join(" ");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "pt-2 me-3 btn btn-outline-secondary d-flex justify-content-between",
        style: {"width":"12rem"},
        onClick: onClickOpenDetail
      }, [
        _createElementVNode("span", null, _toDisplayString(__props.node.nodeName.toLocaleLowerCase()) + " " + _toDisplayString(_unref(selectedNode).id), 1),
        _hoisted_3
      ]),
      _createElementVNode("div", null, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(posX) ? (posX).value = $event : null)),
          class: "form-control mx-2 px-1",
          style: {"width":"8rem"},
          type: "number",
          step: "0.1",
          onFocusin: focusin,
          onFocusout: focusout
        }, null, 544), [
          [_vModelText, _unref(posX)]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(posY) ? (posY).value = $event : null)),
          class: "form-control mx-2 px-1",
          style: {"width":"8rem"},
          type: "number",
          step: "0.1",
          onFocusin: focusin,
          onFocusout: focusout
        }, null, 544), [
          [_vModelText, _unref(posY)]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(posZ) ? (posZ).value = $event : null)),
          class: "form-control mx-2 px-1",
          style: {"width":"8rem"},
          type: "number",
          step: "0.1",
          onFocusin: focusin,
          onFocusout: focusout
        }, null, 544), [
          [_vModelText, _unref(posZ)]
        ])
      ])
    ]),
    (isOpenedDetail.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " <" + _toDisplayString(__props.node.nodeName.toLocaleLowerCase()) + " " + _toDisplayString(_unref(attributesStr)) + "/> ", 1))
      : _createCommentVNode("", true)
  ]))
}
}

})